import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { of } from 'rxjs';
import { Constants } from 'src/app/core/constants';
import { QueryAssignmentsForPEDTO } from 'src/app/models/internal/query-assignments-for-pe-dto';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { MatDialog } from '@angular/material/dialog';
import { AssignNewPeComponent } from '../assign-new-pe/assign-new-pe.component';


@Component({
  selector: 'app-unassigned-pe',
  templateUrl: './unassigned-pe.component.html',
  styleUrls: ['./unassigned-pe.component.scss']
})
export class UnassignedPeComponent extends BaseGridPage implements OnInit, AfterViewInit {

  appSettings: AppSettings;
  unassignedpe_SearchForm: FormGroup;
    peList: number[];
    unassignedPeList: any[];
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    sourceTypeId: number;
  public formErrors = {
    SourceTypeId: '',
    };

    searchClicked = false;
  constructor(
    private dataService: DataService,
        private fb: FormBuilder,
        private toastService: ToastService,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        private spinnerService: SpinnerService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private matDialog: MatDialog
  ) { 
    super(localstorageService, logger, appSettings);
    this.unassignedpe_SearchForm = this.fb.group({
            SourceTypeId: [null]
        });
        this.appSettings = appSettings;
       
  }

  ngOnInit() {
    this.initFilterValues();
    this.searchClicked = true;
    this.getSourceTypes();
    this.getPartSystems();
  }

  initFilterValues(): void {
    this.filter = new SearchFilter();
  }

fillGrid(): void {
  this.filter.Skip = this.skip;
  this.filter.Take = this.pageSize;
  this.UpdateFilter();
  this.getAllUnAssignedPE();
}

//tms-26081 get all unassigned package engineer assignments based on locations
getAllUnAssignedPE() {
  this.UpdateFilter();
  const queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO = new QueryAssignmentsForPEDTO();
  queryAssignmentsForPEDTO.SearchFilter = this.filter;      
  if(queryAssignmentsForPEDTO.SearchFilter.SearchFilterConditions.length > 0){
    this.dataService
    .getUnassignedPE(queryAssignmentsForPEDTO)
    .subscribe((response: any) => {
        if (response != null) {
            this.unassignedPeList = response.Data;
            this.gridView = of({
                data: response.Data,
                total: response.Total ? response.Total : 0,
            });     
        }
    });
  }
}

UpdateFilter() {       
  this.unassignedpe_SearchForm.clearValidators();
  this.filter.SearchFilterConditions = [];
  this.filter = this.setFilterCondition(this.filter, this.unassignedpe_SearchForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
}

searchUnassignedPE() {
  this.ValidateSearchForm();
  if (this.unassignedpe_SearchForm.valid) {
      // get current assignments
      this.searchClicked = true;
      // this.UpdateFilter();
      this.search();
  }
}

clearFilter() {
  this.unassignedpe_SearchForm.reset();
  this.unassignedPeList = [];
}

getPartSystems() {        
  this.dataService.getPartSystems().subscribe((response: any) => {
          if (response != null && response.Success) {
            this.partSystemList = response.Data;
          }
      });
}

getPartSystemName(id: number){
  if (id != null) {
      return this.partSystemList.find(x => x.Id === id).Description;
  }
  return '';

}

getSourceTypes() {        
  this.dataService.getParentSourceTypes().subscribe((response: any) => {
      if (response != null && response.Success) {
        this.sourceTypeList = response.Data;
      }
  });
}

getSourceTypeName(id: number){
  if (id != null) {
      return this.sourceTypeList.find(x => x.Id === id).Description;
  }
  return '';

}

checkSearchFormFilter(): boolean {
  return this.unassignedpe_SearchForm.controls['SourceTypeId'].value;
}

ValidateSearchForm() {
  this.formErrors = this.FormService.validateForm(
      <FormGroup>this.unassignedpe_SearchForm,
      this.formErrors
  );
}

assignPEInfo(unassignedPeList: any) {
  const dialogRef = this.matDialog.open(AssignNewPeComponent, {
    height: '600px',
    width: '700px',
    data: unassignedPeList
  });

  dialogRef.afterClosed().subscribe(result => {
    this.fillGrid();
  });
}

}
